import { AUDIO_RATE_TYPES, AUDIO_SUB_TYPES, planTypes } from "@/common/constants";
import BillingMessageBox from "@/components/common/message-box";
import { translation } from "@/plugins/i18n";
import store from "@/store";

export function checkCountriesRegionsOption() {
  const getters = store.getters;
  const audioPlan = getters.getSelectedPlans.find(item => item.type === planTypes.TOLLFREE && item.category === AUDIO_SUB_TYPES.TOLL_FREE);
  const isLKDAudio = getters.getCurrentBasePlanInfo.planType === planTypes.VIDEO_SDK
  if(!audioPlan) return Promise.resolve();

  const { tollFreeProfileData } = audioPlan.cartInfo;
  const getArrs = arrStr => (arrStr || '').split(',').filter(Boolean);
  const callout = getArrs(tollFreeProfileData[AUDIO_RATE_TYPES.CALL_OUT]);
  const tollfree = getArrs(tollFreeProfileData[AUDIO_RATE_TYPES.TOLL_FREE]);
  const premium = getArrs(tollFreeProfileData[AUDIO_RATE_TYPES.PREMIUM]);
  if(isLKDAudio && callout.length) return Promise.resolve();
  if(!isLKDAudio && (callout.length + tollfree.length + premium.length)) return Promise.resolve();

  BillingMessageBox.alert(
    isLKDAudio ? translation('billing.tollfree.select_at_least_one_country') : translation('billing.tollfree.choose_one_option_tpc'),
    'warning'.toUpperCase(),
    {
      confirmButtonText: translation('common.btn_ok')
    }
  );
  return Promise.reject();
}
